import React, { Component } from 'react'
import 'firebase/firestore'
import BlogItem from './BlogItem'
import Preloader from './Preloader'
import { compose } from 'redux'
import { firestoreConnect, isLoaded, isEmpty } from 'react-redux-firebase'
import { connect } from 'react-redux'

export class Blog extends Component {

  state = {
    loaded: isLoaded(this.props.blogs)
  }

  render() {
    return (
        <div className="blog" style={{ textAlign: 'center' }}>
          {
            !isLoaded(this.props.blogs) && isEmpty(this.props.blogs) ? <Preloader /> : (
              
              this.props.blogs.map((blog, index) => {


                return <BlogItem title={blog.title} coverImageURL={blog.coverImageURL} content={blog.content} url={blog.url} summary={blog.summary}index={index + 1} key={index}/>
              
              })
            )
            
            
          }
        </div>
      )
  }
}

export default compose(
  firestoreConnect(() => [{
    collection: 'blogs',
    orderBy: ['timestamp', 'desc']
  }]),
  connect (state => {
    return {
      blogs: state.firestore.ordered.blogs
    }
  })
)(Blog)